import React from "react";
// import DashboardLayout from './screens/DashboardLayout'
import Overview from "./screens/Overview";
import Brochure2 from "./screens/Brochure2";
import { Route, Routes } from "react-router-dom";
import Esyllabus from "./screens/Esyllabus";
import Processes from "./screens/Processes";
import Materials from "./screens/Materials";
import CBT from "./screens/CBT";
import Help from "./screens/Help";
import BrochureInstituitions2 from "./screens/BrochureInstitutions2";
import Help2 from "./screens/Help2";
import Help3 from "./screens/Help3";
import BrochureCourses from "./screens/BrochureCourses";
import EligibilityChecker from "./screens/EligibilityChecker";
import Brochure from "./screens/Brochure";

const App = () => {
  return (
    <div
      className="flex items-center justify-center h-full w-full mx-auto"
      style={{ maxWidth: 1680, margin: "0 auto" }}
    >
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/brochure" element={<Brochure />} />

        <Route
          path="/brochure-by-institution"
          element={<BrochureInstituitions2 />}
        />
        <Route path="/brochure-by-programme" element={<Brochure2 />} />
        <Route path="/brochure-courses" element={<BrochureCourses />} />
        <Route path="/e-syllabus" element={<Esyllabus />} />
        <Route path="/processes" element={<Processes />} />
        <Route path="/materials" element={<Materials />} />
        <Route path="/cbt" element={<CBT />} />
        <Route path="/help" element={<Help />} />
        <Route path="/faq" element={<Help2 />} />
        <Route path="/correction" element={<Help3 />} />
        <Route path="/eligibility-checker" element={<EligibilityChecker />} />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </div>
  );
};

export default App;
